import { render } from "./coloredBreadcrumb.vue?vue&type=template&id=2c898ba0"
import script from "./coloredBreadcrumb.vue?vue&type=script&lang=js"
export * from "./coloredBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__